import { Link } from 'react-router-dom';
import PageHeader from '../components/molecules/PageHeader';
import { useEventDetails } from '../hooks/events.hook';
import {
  TableContainer,
  TableHead,
  TableRow,
  Table,
  TableBody,
  TableCell,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';

const EventDetail = () => {
  const { data, isLoading } = useEventDetails();

  const backLink = <Link to='/manage/events'>Back to event listings</Link>;

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (data === 'NORESULTS') {
    return <div>No such event</div>;
  }

  return (
    <div>
      <PageHeader backLink={backLink}>{data?.event_title}</PageHeader>

      <div className='mb-8 flex h-auto flex-wrap items-center justify-center  font-bold text-secondary-700'>
        <div className='px-4'>
          <Link
            className='flex items-center'
            to={`/manage/events/${data?.event_id}/add-by-name?event-title=${data?.event_title}`}
          >
            <PersonIcon fontSize='small' sx={{ marginRight: '10px' }} /> Add
            attendance by name
          </Link>
        </div>

        <div className='mt-4 px-4 md:mt-0'>
          <Link
            to={`/manage/events/${data?.event_id}/add-by-session?event-title=${data?.event_title}`}
            className='flex items-center'
          >
            <PeopleIcon fontSize='small' sx={{ marginRight: '10px' }} /> Add
            attendance by session / level
          </Link>
        </div>
      </div>

      <TableContainer className=''>
        <Table sx={{ minWidth: 650 }} size='small' aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align='right'>Level</TableCell>
              <TableCell align='right'>Attendance Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.students?.map(student => {
              return (
                <TableRow
                  key={student.student_id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component='th' scope='row'>
                    <Link to={`/manage/students/${student.student_id}`}>
                      {student.student_first_name} {student.student_last_name}
                    </Link>
                  </TableCell>
                  <TableCell align='right'>{student.student_level}</TableCell>
                  <TableCell align='right'>{student.attendance_date}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
export default EventDetail;
